export default "__VITE_ASSET__89f8aca7__"